<template>
  <el-container>
    <el-aside>
      <el-menu :default-openeds="['1', '2', '3', '4', '5', '6']" router>
        <div class="menu-main-title">
          <div class="box">
            <span class="chineseName">金豐保險經紀人</span><br />
            <span class="englishName">KINGFONG INSURANCE BROKERS</span>
          </div>
        </div>
        <el-menu-item index="0" route="/"><i class="el-icon-s-home"></i>回首頁</el-menu-item>
        <el-submenu index="1">
          <template slot="title">首頁</template>
          <el-menu-item index="1-1" :route="{ name: '/insurance-broker/home/news' }">最新消息</el-menu-item>
          <el-menu-item index="1-2" :route="{ name: '/insurance-broker/home/star' }">金豐之星</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">公司簡介</template>
          <el-menu-item index="2-1" :route="{ name: '/insurance-broker/about-us/background' }">公司背景</el-menu-item>
          <el-menu-item index="2-2" :route="{ name: '/insurance-broker/about-us/increase' }">增員天地</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">優勢商品</template>
          <el-menu-item index="3-1" :route="{ name: '/insurance-broker/advantage-product/retail' }">退休規劃</el-menu-item>
          <el-menu-item index="3-2" :route="{ name: '/insurance-broker/advantage-product/inherit' }">財富傳承</el-menu-item>
          <el-menu-item index="3-3" :route="{ name: '/insurance-broker/advantage-product/health' }">醫療照護</el-menu-item>
          <el-menu-item index="3-4" :route="{ name: '/insurance-broker/advantage-product/business' }">企業保險</el-menu-item>
          <el-menu-item index="3-5" :route="{ name: '/insurance-broker/advantage-product/labor' }">職災保險</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">培訓體系</template>
          <el-menu-item index="4-1" :route="{ name: '/insurance-broker/training-system/basic' }">基礎培訓</el-menu-item>
          <el-menu-item index="4-2" :route="{ name: '/insurance-broker/training-system/professional' }">專業行銷</el-menu-item>
          <el-menu-item index="4-3" :route="{ name: '/insurance-broker/training-system/video' }">視訊直播教學</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">榮譽體系</template>
          <el-menu-item index="5-1" :route="{ name: '/insurance-broker/honor-system/system' }">榮譽獎勵辦法</el-menu-item>
          <el-menu-item
            index="5-2"
            :route="{
              name: '/insurance-broker/honor-system/rank/month/case-number',
            }"
            >件數高手</el-menu-item
          >
          <el-menu-item
            index="5-3"
            :route="{
              name: '/insurance-broker/honor-system/rank/month/performance',
            }"
            >業績高手</el-menu-item
          >
          <el-menu-item
            index="5-4"
            :route="{
              name: '/insurance-broker/honor-system/rank/month/office',
            }"
            >榮譽營業處</el-menu-item
          >
          <el-menu-item index="5-5" :route="{ name: '/insurance-broker/honor-system/rank/year' }">年度排行榜</el-menu-item>
          <el-menu-item index="5-6" :route="{ name: '/insurance-broker/honor-system/rank/history' }">歷年榮譽榜</el-menu-item>
          <el-menu-item index="5-7" :route="{ name: '/insurance-broker/honor-system/travel' }">海外旅遊</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">活動花絮</template>
          <el-menu-item index="6-1" :route="{ name: '/insurance-broker/activity/travel' }">海外旅遊</el-menu-item>
          <el-menu-item index="6-2" :route="{ name: '/insurance-broker/activity/party' }">尾牙春酒</el-menu-item>
          <el-menu-item index="6-4" :route="{ name: '/insurance-broker/activity/training' }">培訓活動</el-menu-item>
          <el-menu-item index="6-3" :route="{ name: '/insurance-broker/activity/charity' }">公益活動</el-menu-item>
        </el-submenu>
        <el-menu-item index="7" :route="{ name: '/insurance-broker/law-compliance' }">法令遵循專區</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="pageName">
          {{ this.$route.meta.title }}
        </div>
        <el-button class="logoutBtn" @click="logout" size="small">登出</el-button>
        <div class="bottom-line"></div>
      </el-header>
      <router-view class="main-content"></router-view>
    </el-container>
  </el-container>
</template>

<script>
import { AdminLogout } from "@/assets/js/api";

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
      titleTemplate: "%s | 金豐保險經紀人",
    };
  },
  created() {
    const admin = sessionStorage.getItem("_admin");
    if (admin !== "kingfongAdmin") {
      this.$router.push("/");
    }
  },
  methods: {
    logout() {
      AdminLogout()
        .then(() => {
          sessionStorage.removeItem("_admin");

          this.$router.push({ name: "login" });
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },
  },
};
</script>
